/** Copy for /b2b solar dynamic-tariff case. Keep in sync with sales/ukraine/CASE_SOLAR_DYNAMIC_TARIFF.*.md */

export const B2B_SOLAR_CASE_COPY = {
  ua: {
    figureAlt: 'День і ніч на ЕЗС: 6 грн при сонці і 23 грн увечері',
    headline:
      'Вдень батарея повна, сонце пропадає, а водії приїжджають ввечері і заряджаються від мережі. Знайома історія?',
    introBefore: 'Зараз розкажемо, як ',
    emsName: 'Вирій ЕМС',
    introAfter: ' вивів енергоефективність обʼєкта на новий рівень.',
    lead: 'Партнер 220-km: станція 160 кВт, сонячна генерація 220 кВт у піку, три інвертори Deye по 80 кВт, 3 стійки ємністю 675 кВт·год.',
    wasTitle: 'Було',
    wasBody: [
      'Ціна стояла 18 грн/кВт·год, як у конкурентів.',
      'Вдень батарея набиралась, зайве сонце пропадало. Інвестиція в СЕС простоювала. Водії приїжджали ввечері і брали вже з батареї: плюс 2 грн/кВт·год на амортизацію батареї або взагалі з мережі по 11 грн. Маржа власника мінімальна.',
    ],
    changedTitle: 'Що змінили',
    changedBody: [
      'Активували динамічний тариф від 220-km. Влітку з мережі майже нічого не беремо. Тариф динамічно змінюється залежно від SOC великої батареї на 675 кВт·год.',
    ],
    demandTitle: 'Як відбувається керування попитом',
    demandBody: [
      'У додатку 220-km водій бронює → планує → заряджає.',
      'Через веб-камеру на сторінці старту наступному водію видно, скільки машин перед ним на місці. Видно потужність сесії, скільки сонця зараз і скільки буде завтра, який заряд батареї. Водій сам розуміє, коли дешевше буде чи дорожче.',
      'Перші два-три тижні всі звикали. Потім сарафан: водії пояснили одне одному, як це працює, коли в додатку 220-km вигідні ціни і коли їхати.',
      'Роумінг через EVA Chargers. Станцію бачать 200 тис. користувачів. Близько 40% нові водії, котрі знаходять цю станцію через EVA та додатки-агрегатори з фільтром по ціні. Результат: водії планують маршрут Україною через цю локацію.',
    ],
    betterTitle: 'Стало',
    betterBody: [
      'Сонце перестало пропадати. Воно пішло в машини. Місцеві водії підлаштували обідню перерву, коли зарядка в 2-3 рази дешевша.',
      'Раніше завжди 18 грн. Тепер 6,99 при сонці і 20,99 без нього. Коли хмари, частина все одно їде на 20,99 по звичці. Обсяги майже не падають.',
      'Грошей у власника стало більше. Більший обсяг і більша маржа.',
    ],
    tableCaption: 'У липні тариф тільки запровадили. У серпні він вже дав ефект. Обсяг зріс в 2,3 рази.',
    colMonth: 'Місяць',
    colKwh: 'Заряджено',
    colPaid: 'Сплачено водіями',
    july: 'Липень 2026',
    august: 'Серпень 2026',
    julyKwh: '3 809 кВт·год',
    augustKwh: '8 762 кВт·год',
    julyPaid: '27 153 грн',
    augustPaid: '62 634 грн',
    quoteAfter: 'Результат: попит збільшився, і власник встановив ще одну станцію, теж з динамічним тарифом.',
    source: 'Джерело: білінг 220-km, липень-серпень 2026.',
  },
  ru: {
    figureAlt: 'День и ночь на ЭЗС: 6 грн при солнце и 23 грн вечером',
    headline:
      'Днём батарея полная, солнце пропадает, а водители приезжают вечером и заряжаются из сети. Знакомая история?',
    introBefore: 'Сейчас расскажем, как ',
    emsName: 'Вирий ЭМС',
    introAfter: ' вывел энергоэффективность объекта на новый уровень.',
    lead: 'Партнёр 220-km: станция 160 кВт, солнечная генерация 220 кВт в пике, три инвертора Deye по 80 кВт, 3 стойки ёмкостью 675 кВт·ч.',
    wasTitle: 'Было',
    wasBody: [
      'Цена стояла 18 грн/кВт·ч, как у конкурентов.',
      'Днём батарея набиралась, лишнее солнце пропадало. Инвестиция в СЭС простаивала. Водители приезжали вечером и брали уже из батареи: плюс 2 грн/кВт·ч на амортизацию батареи или вообще из сети по 11 грн. Маржа владельца минимальная.',
    ],
    changedTitle: 'Что изменили',
    changedBody: [
      'Активировали динамический тариф от 220-km. Летом из сети почти ничего не берём. Тариф динамически меняется в зависимости от SOC большой батареи на 675 кВт·ч.',
    ],
    demandTitle: 'Как происходит управление спросом',
    demandBody: [
      'В приложении 220-km водитель бронирует → планирует → заряжает.',
      'Через веб-камеру на странице старта следующему водителю видно, сколько машин перед ним на месте. Видна мощность сессии, сколько солнца сейчас и сколько будет завтра, какой заряд батареи. Водитель сам понимает, когда будет дешевле или дороже.',
      'Первые две-три недели все привыкали. Потом сарафан: водители объяснили друг другу, как это работает, когда в приложении 220-km выгодные цены и когда ехать.',
      'Роуминг через EVA Chargers. Станцию видят 200 тыс. пользователей. Около 40% новые водители, которые находят эту станцию через EVA и приложения-агрегаторы с фильтром по цене. Результат: водители планируют маршрут по Украине через эту локацию.',
    ],
    betterTitle: 'Стало',
    betterBody: [
      'Солнце перестало пропадать. Оно пошло в машины. Местные водители подстроили обеденный перерыв, когда зарядка в 2-3 раза дешевле.',
      'Раньше всегда 18 грн. Теперь 6,99 при солнце и 20,99 без него. Когда облака, часть всё равно едет на 20,99 по привычке. Объёмы почти не падают.',
      'Денег у владельца стало больше. Больший объём и большая маржа.',
    ],
    tableCaption: 'В июле тариф только ввели. В августе он уже дал эффект. Объём вырос в 2,3 раза.',
    colMonth: 'Месяц',
    colKwh: 'Заряжено',
    colPaid: 'Оплачено водителями',
    july: 'Июль 2026',
    august: 'Август 2026',
    julyKwh: '3 809 кВт·ч',
    augustKwh: '8 762 кВт·ч',
    julyPaid: '27 153 грн',
    augustPaid: '62 634 грн',
    quoteAfter: 'Результат: спрос вырос, и владелец установил ещё одну станцию, тоже с динамическим тарифом.',
    source: 'Источник: биллинг 220-km, июль-август 2026.',
  },
  en: {
    figureAlt: 'Day and night at the charger: 6 UAH in the sun and 23 UAH in the evening',
    headline:
      'By day the battery is full, the sun goes unused, and drivers show up in the evening and charge from the grid. Sound familiar?',
    introBefore: 'Here is how ',
    emsName: 'Viriy EMS',
    introAfter: " took this site's energy efficiency to another level.",
    lead: 'A 220-km partner: 160 kW charger, 220 kW peak solar, three 80 kW Deye inverters, three racks totalling 675 kWh.',
    wasTitle: 'Before',
    wasBody: [
      'The price sat at 18 UAH/kWh, same as the competitors.',
      'By day the battery filled up and leftover solar was wasted. The PV plant sat idle. Drivers arrived in the evening and took power from the battery: +2 UAH/kWh in battery wear, or from the grid at 11 UAH. Owner margin was minimal.',
    ],
    changedTitle: 'What changed',
    changedBody: [
      'We switched on the 220-km dynamic tariff. In summer we take almost nothing from the grid. The tariff moves with SOC of the 675 kWh battery.',
    ],
    demandTitle: 'How demand is steered',
    demandBody: [
      'In the 220-km app the driver reserves → plans → charges.',
      'A webcam on the start page shows the next driver how many cars are ahead on site. They also see session power, how much sun there is now and how much there will be tomorrow, and the battery charge. The driver can tell when it will be cheaper or more expensive.',
      'The first two or three weeks, people were still getting used to it. Then word of mouth: drivers explained to each other how it works, when prices in the 220-km app are good, and when to come.',
      'Roaming through EVA Chargers. 200k users can see the site. About 40% are new drivers who find it via EVA and aggregator apps with a price filter. Result: drivers plan a trip across Ukraine through this location.',
    ],
    betterTitle: 'After',
    betterBody: [
      'Solar stopped going to waste. It went into cars. Local drivers moved their lunch break to when charging is 2-3 times cheaper.',
      'It used to be 18 UAH all day. Now 6.99 with sun and 20.99 without. On cloudy days some still show up at 20.99 out of habit. Volume barely drops.',
      'The owner makes more money. Higher volume and higher margin.',
    ],
    tableCaption:
      'In July they had only just introduced the tariff. In August it already showed. Volume grew 2.3 times.',
    colMonth: 'Month',
    colKwh: 'Charged',
    colPaid: 'Paid by drivers',
    july: 'July 2026',
    august: 'August 2026',
    julyKwh: '3,809 kWh',
    augustKwh: '8,762 kWh',
    julyPaid: '27,153 UAH',
    augustPaid: '62,634 UAH',
    quoteAfter: 'Result: demand grew, and the owner installed another station, also on the dynamic tariff.',
    source: 'Source: 220-km billing, July-August 2026.',
  },
};

export function getB2bSolarCaseCopy(language) {
  const lang = String(language || 'ua').toLowerCase();
  if (lang.startsWith('en')) return B2B_SOLAR_CASE_COPY.en;
  if (lang.startsWith('ru')) return B2B_SOLAR_CASE_COPY.ru;
  return B2B_SOLAR_CASE_COPY.ua;
}
